// src/lib/videoAlphaSupport.ts
//
// Phase 7c — runtime detection of WebM VP9-alpha playback support.
//
// Why: the Phase 7c matting follow-up (veed/fal) produces a single WebM
// VP9-alpha file. Modern Chromium-based browsers (desktop Chrome, Android
// Chrome, Telegram Desktop, modern Edge) decode the alpha channel
// natively. iOS WebKit (Safari, Telegram in-app browser on iOS) does NOT
// — the alpha channel is ignored and pixels outside the subject render
// opaque black. There's no UA-independent feature test that's both
// reliable and cheap, so we use a small UA-based gate.
//
// When this returns false the renderers fall back to ChromaKeyVideo
// (canvas chroma-key over the magenta MP4) which works on every
// platform. The matting pipeline still runs server-side and the WebM
// stays available — when iOS WebKit adds reliable VP9-alpha support, or
// we ship an HEVC-alpha fallback, we just flip this flag.

/** Memoized: same answer every call within a session. */
let cached: boolean | null = null

export function supportsVp9Alpha(): boolean {
  if (cached !== null) return cached
  if (typeof navigator === 'undefined') {
    cached = false
    return cached
  }
  const ua = navigator.userAgent || ''
  // iOS / iPadOS WebKit (also covers Telegram's in-app browser on iOS,
  // which uses WKWebView). iPadOS 13+ reports "Macintosh" with touch
  // support, so include that detection too.
  const isiOS =
    /iPad|iPhone|iPod/.test(ua)
    || (ua.includes('Macintosh') && typeof document !== 'undefined' && 'ontouchend' in document)
  cached = !isiOS
  return cached
}
